// extracted by mini-css-extract-plugin
export default {"badge":"BadgeList_badge__baKGu"};